import {useSessionStore} from "../store";
import {useEffect} from "react";

export const useSessionTimer = () => {
  const {
    session_remaining_seconds: sessionRemainingSeconds,
    setSessionRemainingSeconds,
  } = useSessionStore();

  useEffect(() => {
    if (sessionRemainingSeconds) {
      const timer = setInterval(() => {
        setSessionRemainingSeconds(sessionRemainingSeconds - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [sessionRemainingSeconds]);

  return {
    sessionRemainingSeconds,
  };
};
